<template>
  <epc-modal-wrapper :active.sync="isModalActive" :title="$t('upload_image')" :width="480">
    <report-image-upload-form ref="form"
      :is-gantt="isGantt"
      :show-caption="showCaption"
      @submit="onSubmit"
      @cancel="hide" />
  </epc-modal-wrapper>
</template>

<script>
// Envoltorio (solo presentación): mete el formulario de subida en EpcModalWrapper y expone
// la API imperativa show()/hide() del legacy. Reemite el resultado como `load:image_section`
// con la misma forma { tabId, loadImageIdx, image } que espera el manejador.
import EpcModalWrapper from '·/components/epc-modal-wrapper.vue'
import ReportImageUploadForm from './report-image-upload-form.vue'

export default {
  name: 'report-image-upload-modal',

  components: { EpcModalWrapper, ReportImageUploadForm },

  props: {
    // Muestra el input "Pie de foto" en el formulario.
    showCaption: { type: Boolean, default: true },
  },

  data() {
    return {
      isModalActive: false,
      tabId: null,
      loadImageIdx: null,
      isGantt: false,
    }
  },

  methods: {
    // El formulario entrega { name, details, image(File) }; añadimos el destino (tab/slot).
    onSubmit({ name, details, image }) {
      this.$emit('load:image_section', {
        tabId: this.tabId,
        loadImageIdx: this.loadImageIdx,
        image: { name, details, image },
      })
    },

    show(data) {
      this.tabId = data.tabId
      this.loadImageIdx = data.imgIndex
      this.isGantt = data.isGantt || false
      this.isModalActive = true
      this.$nextTick(() => { if (this.$refs.form) this.$refs.form.reset() })
    },

    hide() {
      this.isModalActive = false
      this.tabId = null
      this.loadImageIdx = null
      if (this.$refs.form) this.$refs.form.reset()
    },
  },
}
</script>
